import { render, staticRenderFns } from "./his-menzhen.vue?vue&type=template&id=41a18461&scoped=true&"
import script from "./his-menzhen.vue?vue&type=script&lang=ts&"
export * from "./his-menzhen.vue?vue&type=script&lang=ts&"
import style0 from "./his-menzhen.vue?vue&type=style&index=0&id=41a18461&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a18461",
  null
  
)

export default component.exports